module.exports = __webpack_public_path__ + "img/ic_foot_hight_5.39a67de6.png";